import { Layout, Page } from "@fdoh/health-ui-react";
import { AdditionalInformationFormInput } from "../Components/AdditionalInformation.types";
import { AdditionalInformationForm } from "../Components/AdditionalInformationForm";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useHistory, useLocation, useParams } from "react-router-dom";

const CreateAdditionalInformationPage = () => {
    const { search } = useLocation();
    const { state }: any = useLocation();
    const lastInspectionStatusData = state?.lastInspectionStatusData; 
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

    const prePopulatedData = lastInspectionStatusData ? {
        ...lastInspectionStatusData,
        ehdcontactId: lastInspectionStatusData.ehdcontactId,
        drainfieldProductMakeId: lastInspectionStatusData.typeofDrainfieldProductMakeId,
        drainfieldProductModelId: lastInspectionStatusData.typeofDrainfieldProductModelID
    } : null;
    
  return applicationId ? (
    <Page.Container>
     <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <AdditionalInformationForm
            id="AdditionalInformationForm"
            title="Additional Information"
            action="post"
                      applicationId={applicationId ? applicationId : 0}
                      applicationInspectionId={inspectionId ? inspectionId : 0}
                      returnPath={`/inspectionDetails/${inspectionId}`}
                      values={prePopulatedData}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>

  </div>;
};

export default CreateAdditionalInformationPage;